import React from 'react';

// redux
import withShipment from "../../withShipment";
import {userInfoSelector} from "../../redux/selectors/auth";
import { getSpaceId } from "../../hive/getSpaceId";


import DateFnsUtils from "@date-io/date-fns";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";


import ErrorFeedbackBar from '../global/ErrorFeedbackBar';

import CustomToolbar from "../global/CustomToolbar";
import RefreshIcon from "@material-ui/icons/Refresh";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { HourglassEmptyTwoTone} from "@material-ui/icons";
import {refreshSelector} from "../../redux/selectors/dashboard";
import {DASHBOARD as DASHBOARD_ENDPOINTS} from "../global/Server/endpoints";
import {apiRequest} from "../../redux/actions/api";
import './Dashboard.responsive.css';



class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardsData: [],
      dashboardCards: [],
    };
  };

  componentDidMount() {
    this.refreshComponent();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    if (prevProps.refresh !== this.props.refresh) {
      this.refreshComponent();
    }

  }

  fetchDashboardFolders = () => {
    // Routed through the generic api saga (Redux Saga + AuthUtil) instead
    // of a direct axios.post. The saga handles the bearer token, the
    // 401/403 → /login bounce, and pushes any error into the global
    // ErrorFeedbackBar automatically.
    this.props.apiRequest({
      key: 'dashboard/folders',
      endpoint: DASHBOARD_ENDPOINTS.LIST_FOLDERS,
      data: { companyId: getSpaceId(this.props.userInfo) },
      onSuccess: (payload) => {
        if (!payload || !Array.isArray(payload.data)) return;

        // Folders are scoped to the active workspace on the server, so every
        // folder returned belongs to this user's space — show them all. (The
        // legacy per-user `selectedFolders` filter is superseded by workspaces.)
        this.setState({ dashboardCards: payload.data, cardsData: payload.data });
      },
    });
  };


  refreshComponent = () => {
    this.fetchDashboardFolders();
  };


  render() {


    // Managing the main folders lives in Manage Folder (ROLE_MANAGE_FOLDER /
    // route id 'folder'). Only surface the add-circle to users who can.
    const userRoutes = this.props.userInfo?.routes ? [...this.props.userInfo.routes] : [];
    // Document Center users manage their own folders (folders are space-scoped).
    const canManageFolders = userRoutes.includes('document-center') || userRoutes.includes('folder');

    let headerButtons = [];

    if (canManageFolders) {
      headerButtons.push({
        icon: <AddCircleIcon />,
        handler: () => this.props.history.push('/settings/manage-folder'),
        title: 'Create / manage folders',
      });
    }

    headerButtons.push({
      icon: this.props.refreshing ? <HourglassEmptyTwoTone /> : <RefreshIcon />,
      handler: this.refreshComponent,
      title: this.props.refreshing ? 'Refreshing...' : 'Refresh',
      disabled: this.props.refreshing,
    });


    return (
      <>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <ErrorFeedbackBar />
          <CustomToolbar
            // The shell top bar already shows the "Document Center" app title, so
            // the right-aligned toolbar title is redundant here — leave it blank.
            title={''}
            createTitle={'Document Center'}
            backTitle={'Back To Menu'}
            onClick={() => {}}
            headerButtons={headerButtons}
          />
        </MuiPickersUtilsProvider>

        <div className="bn-dashboard">
          {this.state.cardsData.length === 0 ? (
            <div className="bn-dashboard-empty">
              <span
                className="bn-dashboard-empty-icon"
                role="img"
                aria-label="Empty folder"
              >
                📁
              </span>
              <div className="bn-dashboard-empty-title">No folders yet</div>
              <div className="bn-dashboard-empty-sub">
                {canManageFolders
                  ? 'Create your main folders to start organizing documents.'
                  : 'Folders you have access to will appear here.'}
              </div>
              {canManageFolders && (
                <button
                  type="button"
                  className="bn-dashboard-empty-btn"
                  onClick={() => this.props.history.push('/settings/manage-folder')}
                >
                  <AddCircleIcon fontSize="small" />
                  Create folders
                </button>
              )}
            </div>
          ) : (
            <div className="bn-dashboard-grid">
              {this.state.cardsData.map((card, index) => (
                <div
                  className="bn-dashboard-card"
                  key={card.dashboardFolderId || index}
                  onClick={() =>
                    this.props.history.push({
                      pathname: '/file-manager',
                      state: {
                        selectedFolder: card.title,
                        parentId: card.dashboardFolderId,
                      },
                    })
                  }
                >
                  <div className="bn-dashboard-card-media">
                    {card.imageUrl ? (
                      <img
                        src={card.imageUrl}
                        alt={card.title}
                      />
                    ) : (
                      <span
                        className="bn-dashboard-card-placeholder"
                        role="img"
                        aria-label="Folder"
                      >
                        📁
                      </span>
                    )}
                  </div>
                  <div className="bn-dashboard-card-body">
                    <div className="bn-dashboard-card-title">{card.title}</div>
                    <div className="bn-dashboard-card-arrow">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" strokeWidth="2.5"
                           strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 18l6-6-6-6" />
                      </svg>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

      </>
    )
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  refresh: refreshSelector(state),
});

const actionCreators = {
  apiRequest,
}


Dashboard.propTypes = {

}

Dashboard.defaultProps = {

}

export default withShipment({
  mapStateToProps,
  actionCreators
}, Dashboard);